var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"form sidebar"},[_c('FilterBox',{attrs:{"title":_vm.countries.description,"code":"countries","items":_vm.countries.contents}}),_c('FilterBox',{attrs:{"title":_vm.areas.description,"code":"areas","items":_vm.areas.contents}}),_c('FilterBox',{attrs:{"title":_vm.types.description,"code":"types","items":_vm.types.contents}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }